export var PresetHeader;
(function (PresetHeader) {
    PresetHeader.MAGIC_HEADER_OPEN = 0x4F505245; // OPRE
    PresetHeader.FORMAT_VERSION = 1;
})(PresetHeader || (PresetHeader = {}));
